export class SpedFixedUserPermission {
    ViewSpEdHome: boolean;
    ManageAssessmentConfiguration: boolean;
    ManageNarratives: boolean;
    MaintainComplianceRuleTable: boolean;
    ManageFormsFieldsCollectionConfiguration: boolean;
    MaintainDistrictTablesCodeGoalsAccomm: boolean;
    MaintainTeamMemberPermissionsonDocumentsAndForms: boolean;
    ViewAllSpEdDocuments: boolean;
    AddAllSpEdDocuments: boolean;
    MaintainAllSpEdDocuments: boolean;
    MaintainAllSpEdDocumentsInFinalStatus: boolean;
    DeleteAllSpEdDocuments: boolean;
    ImportDocumentAndAttachToAllSpEdDocuments: boolean;
    ComplianceCheckSpEdDocument: boolean;
    OverrideComplianceErrors: boolean;
    ManageDocumentStatus: boolean;
    AssignMySelfAsCaseManager: boolean;
    AssignAnyoneAsCaseManager: boolean;
    SpEdReports: boolean;
    AssessmentDistrictAdminRead: boolean;
    AssessmentDistrictAdminEdit: boolean;
    AssessmentSiteAdminEdit: boolean;
    AssessmentSiteAdminRead: boolean;
    AssessmentUsersRead: boolean;
    AssessmentUsersEdit: boolean;
    MaintainAllSpEdDocumentInCompletedByCaseManagerStatus: boolean;
    DeleteCaseManagerHistory: boolean;
    CheckOutDocument: boolean;
    ViewStudentIEPAlertIcon: boolean;
    ViewSpecialServicesHome: boolean;
    Manage504FormsFieldsCollectionConfiguration: boolean;
    Maintain504DistrictTablesCodeGoalsAccomm: boolean;
    Maintain504TeamMemberPermissionsonDocumentsAndForms: boolean;
    ViewAll504Documents: boolean;
    AddAll504Documents: boolean;
    MaintainAll504Documents: boolean;
    MaintainAll504DocumentsInFinalStatus: boolean;
    DeleteAll504Documents: boolean;
    ImportDocumentAndAttachToAll504Documents: boolean;
    Manage504DocumentStatus: boolean;
    AssignMySelfAs504CaseManager: boolean;
    AssignAnyoneAs504CaseManager: boolean;
    Sec504Reports: boolean;
    Delete504CaseManagerHistory: boolean;
    CheckOut504Document: boolean;
}
export class SpedUserPermission {
    CollectionId: number;
    CollectionName: string;
    View: boolean;
    AddAndCopyNew: boolean;
    Maintain: boolean;
    MaintainInFinalStatus: boolean;
    Delete: boolean;
    ImportDocumentAndAttachToDocument: boolean;
}
export class ExportResult {

	// Server Properties
	CourseSearch: boolean;
	CreatedBy: number;
	CreatedOn: string;
	Delimiter = 'Comma';
	ExportType = 'XLSX';
	IncludeColumnHeadings = true;
	OtherDelimiter: string;
}
